import React, {useContext, Fragment, useState, useEffect} from "react";
import { List, Divider, Stack } from '@mui/material';
import Flat from "./Flat";
import { useTranslation } from 'react-i18next';
import useLog from "../../hooks/useLog";

const FlatsView = ({buildings, selectedBuildingIndex}) => {

    useEffect(() => {
        console.log("FlatsView: Buildings changed: ", buildings);
        console.log(buildings.length);

    }, [buildings]);
    const { t } = useTranslation();
    const [selectedFlatId, setSelectedFlatId] = useState(null);
    const { LogInfo } = useLog();

    const handleFlatSelected = (flatId) => {
        LogInfo("Flat selected: " +flatId);
        setSelectedFlatId(prevId => (prevId === flatId ? null : flatId));
    };

    useEffect(() => {
      setSelectedFlatId(null);  
    }, [selectedBuildingIndex]);

  return (
    <Stack spacing={2}>
      <List sx={{
        maxHeight: '650px',
        minWidth: '500px',
        overflowY: 'auto',
        overflowX: 'hidden',
        '&::-webkit-scrollbar': {
          width: '4px'
        },
        '&::-webkit-scrollbar-track': {
          background: 'gray',
          width: '1px'
        },
        '&::-webkit-scrollbar-thumb': {
          background: 'white',
          borderRadius: '2px'
        },
        '&::-webkit-scrollbar-thumb:hover': {
          background: 'rgba(255, 255, 255, 0.8)'
        },
        '&::-webkit-scrollbar-thumb:vertical': {
          width: '6px'
        }
      }}>
      {buildings && buildings.length>0 && buildings[selectedBuildingIndex].flats.filter(flatObj => flatObj.flatname !== "lobby") // Filter out the flat with flatName "lobby"
          .map((flatObj, index) => (
            <Fragment key={flatObj.flatid}>
              {index !== 0 && <Divider color="gray"/>}
              <Flat flat={flatObj} 
                    selectedFlatId={selectedFlatId} 
                    handleFlatSelected={handleFlatSelected} />
            </Fragment>
          ))}
      </List>
    </Stack>
  );
};
export default FlatsView;
